<div class="box" [class.access-dates-dialog]="data.isAccessDates">
    <div class="header">
        <div class="content" [ngClass]="'greendAnalityco' || 'primary'">{{data.title || 'Sin Title'}}</div>
    </div>
    <div class="content-card list-card" >

        <div class="sub-header" *ngIf="data.url !== ''">
            <div class="sub-content greendAnalityco">{{'Verificar orden de contratación' || 'Sin nombre'}}</div>
        </div>
        <div class="documento" *ngIf="data.url !== ''">
            <div>{{data.name || 'Sin nombre'}}</div>
            <mat-icon (click)="show()">visibility</mat-icon>
        </div>
        <div class="input-field" *ngIf="data.isRechazo && !data.isAccessDates">
            <label><strong>COMENTARIO</strong></label>
            <textarea [(ngModel)]="comment" maxlength="280" rows="7"></textarea>
        </div>
        <div class="input-field access-comment" *ngIf="data.isAccessDates">
            <label class="access-label">Comentario</label>
            <textarea [(ngModel)]="comment" maxlength="280" rows="6"></textarea>
        </div>
        <form [formGroup]="form" autocomplete="off" style="width: 100%;">
            <mat-form-field class="input-field" appearance="outline" *ngIf="this.data.isRetiro !== undefined">
                <label><strong>VALOR REVISADO</strong></label>
                <input matInput #moneySalary formControlName="Severance" style="text-align: right;" >
            </mat-form-field>
            <div class="access-dates-block" *ngIf="data.isAccessDates">
                <label class="access-label">Fechas de acceso</label>
                <div class="access-dates-row">
                    <div class="access-date-field">
                        <span class="access-date-label">INICIO</span>
                        <div class="access-date-box">
                            <input #startNative class="access-date-native" type="datetime-local" formControlName="StartDate"
                                [min]="minToday" [max]="data.finishDate">
                            <mat-icon class="access-date-icon" (click)="openPicker(startNative)">event</mat-icon>
                        </div>
                    </div>
                    <div class="access-date-field">
                        <span class="access-date-label">FIN</span>
                        <div class="access-date-box">
                            <input #finishNative class="access-date-native" type="datetime-local" formControlName="FinishDate"
                                [min]="form.get('StartDate')?.value || minToday" [max]="data.finishDate">
                            <mat-icon class="access-date-icon" (click)="openPicker(finishNative)">event</mat-icon>
                        </div>
                    </div>
                </div>
                <div class="access-dates-error" *ngIf="form.get('StartDate')?.hasError('maxDate') || form.get('FinishDate')?.hasError('maxDate')">
                    <mat-icon>error_outline</mat-icon>
                    <span>Las fechas de acceso no pueden superar la fecha de fin del contrato.</span>
                </div>
                <div class="access-dates-error" *ngIf="form.get('StartDate')?.hasError('minDate')">
                    <mat-icon>error_outline</mat-icon>
                    <span>La fecha de inicio no puede ser anterior a hoy.</span>
                </div>
                <div class="access-dates-error" *ngIf="form.get('FinishDate')?.hasError('minStartDate')">
                    <mat-icon>error_outline</mat-icon>
                    <span>La fecha de fin no puede ser anterior a la fecha de inicio.</span>
                </div>
                <div class="access-dates-notice">
                    <mat-icon>info_outline</mat-icon>
                    <span>Al aprobar la solicitud, se fijarán las fechas de inicio y fin de acceso ingresadas en esta pantalla.</span>
                </div>
            </div>
        </form>
        <br>
        <div class="actions-dialog"style="margin: 3px;">
            <button mat-button class="btn-cancelar" (click)="onNoClick()" >CANCELAR</button>&nbsp;&nbsp;
            <button mat-button class="btn-generar" [disabled]="data.isAccessDates && form.invalid" (click)="acept()">{{data.aceptText}}</button>
        </div>
    </div>
    <!-- SUB-SUBTITLE 3 ITEMS -->

    <!-- pre-loading -->
    <!-- <div class="content-card list-card pre-content" *ngIf="!personalContractProyect">
        <div class="form-group-list" *ngFor="let item of production.pre_loading">
            <div class="card">
                <div class="relational-info">
                    <div class="desc flex" style="width: 18px;">
                        <div class="icon-pre pre-loading"></div>
                        <div class="title-pre pre-loading"></div>
                    </div>
                    <div class="icon-pre pre-loading"></div>
                </div>
                <div class="card-content">
                    <div class="pre-img pre-loading"></div>
                    <div class="content-information">
                        <div class="text-pre pre-loading"></div>
                        <div class="text-pre pre-loading"></div>
                        <div class="text-pre pre-loading"></div>
                    </div>
                </div>
            </div>
            <hr>
        </div>
    </div> -->

</div>
